import { useLocale } from '@dreamstack/i18n'

const ACCENTRO_WER_BASE_URL = 'https://accentro.de'

const werPathsByLocale = {
  de: `${ACCENTRO_WER_BASE_URL}/wohneigentumsreport`,
  en: `${ACCENTRO_WER_BASE_URL}/en/homeownership-report`,
}

const wkrPathsByLocale = {
  de: `${ACCENTRO_WER_BASE_URL}/wohnkostenreport`,
  en: `${ACCENTRO_WER_BASE_URL}/en/housing-cost-report`,
}

export const useWerUrl = () => {
  const locale = useLocale()
  return werPathsByLocale[locale]
}

export const useWkrUrl = () => {
  const locale = useLocale()
  return wkrPathsByLocale[locale]
}
